import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-next",
  "use": "icon-next-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol viewBox=\"0 0 500 501\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-next\"><title>icon-next</title><path fill=\"currentColor\" d=\"M419.012 259.592H50v-16.188h369.012L293.043 117.446 304.49 106 450 251.498 304.49 397l-11.447-11.446z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol